<template>
  <!--添加现场、 拍证据-->
  <div class="evidence">
    <header>
      <i v-if="videoUrl" @click="videoUrl = null" class="el-icon-arrow-left icon"></i>
      <i v-else class="el-icon-arrow-left icon"></i>
      <p>拍证据</p>
    </header>

    <div v-if="videoUrl" class="main">
      <video :src="videoUrl" controls="controls" width="100%"></video>
    </div>
    <div v-else class="main">
      <div class="list-sign">
        <div class="sign-item">
          <h3 class="text-center">温馨提示</h3>
          <p>可选择上传<span class="color-danger">图片</span>或<span class="color-danger">视频</span>证据，若不需要请直接返回 </p>
          <p>图片：（如单据、房本信息），视频：（如签署录像、卸货过程）</p>
        </div>

        <div class="sign-item">
          <ul class="list-cel">
            <li>
              <img v-if="evidenceFront" :src="showImg(evidenceFront.thumbnailImg)" alt="">
              <img v-else src="/images/m/identity-1.png" alt="">
            </li>
            <li>
              <template v-if="evidenceFront">
                <b>{{evidenceFront.updateTimeFmt}}</b><br/>
                <small>{{evidenceFront.updateTimeSecond}}</small> 证件正面
              </template>
              <b v-else>正面手持证件示例</b>
            </li>
            <li class="text-right">
              <el-button v-if="evidenceFront" @click="delEvidence(evidenceFront.evidenceId)" type="danger" size="small">删除</el-button>
              <el-upload  v-else  action="" :auto-upload="false" :show-file-list="false" :on-change="handleImgClick0"
                         style="display: inline-block;margin-left: 15px;" accept="image/*">
                <el-button slot="trigger" type="success" size="small">添加</el-button>
              </el-upload>
            </li>
          </ul>
          <ul class="list-cel">
            <li>
              <img v-if="evidenceReverse" :src="showImg(evidenceReverse.thumbnailImg)" alt="">
              <img v-else src="/images/m/identity-2.png" alt="">
            </li>
            <li>
              <template v-if="evidenceReverse">
                <b>{{evidenceReverse.updateTimeFmt}}</b><br/>
                <small>{{evidenceReverse.updateTimeSecond}}</small> 证件背面
              </template>
              <b v-else>证件背面示例</b>
            </li>
            <li class="text-right">
              <el-button v-if="evidenceReverse" @click="delEvidence(evidenceReverse.evidenceId)" type="danger" size="small">删除</el-button>
              <el-upload v-else action="" :auto-upload="false" :show-file-list="false" :on-change="handleImgClick1"
                         style="display: inline-block;margin-left: 15px;" accept="image/*">
                <el-button slot="trigger" type="success" size="small">添加</el-button>
              </el-upload>
            </li>
          </ul>

          <!--视频签署证据-->
          <ul v-if="videoSignInfo && videoSignInfo.length" v-for="(item, i) in videoSignInfo" class="video-sign" :key="i">
            <li class="logo"></li>
            <li class="cont">
              <b v-if="item.signNames">{{item.signNames}}</b>
              <p v-if="item.duration">时长：{{item.duration | secToTime}}</p>
            </li>
          </ul>

          <template v-if="evidenceInfo">
            <ul v-for="(item,i) in evidenceInfo" class="list-cel" :key="i">
              <li>
                <template v-if="item.evidenceVideoUrl">
                  <img @click="playVideo(item.evidenceVideoUrl)" src="/images/m/play.png" class="play-video">
                </template>
                <img v-if="item.thumbnailImg" :src="showImg(item.thumbnailImg)" alt="">
                <img v-else :src="item.url" alt="">
              </li>
              <li>
                <template v-if="item.url">正在上传</template>
                <template v-else>
                  <b>{{item.updateTimeFmt}}</b><br/>
                  <small>{{item.updateTimeSecond}}</small>
                </template>
              </li>
              <li class="text-right">
                <el-button v-if="item.evidenceId" @click="delEvidence(item.evidenceId)" type="danger" size="small">删除</el-button>
              </li>
            </ul>
          </template>
        </div>
      </div>
      <p class="remark">备注:请根据需求选择添加图片或视频,大小不超过30MB。</p>
    </div>

    <div class="footer">
      <ul class="navbar">
        <li style="position: relative">
          <input @change="handleImgClick2" type="file" capture="camera" accept="image/*" id="cameraInput" name="cameraInput"
                 class="btn btn-primary btn-lg btn-block" style="position: absolute; width: 100%; height: 100%; opacity: 0; z-index: 999; top:0; left: 0;" >
          <i class="icon icon-addimage"></i>
          添加图片
        </li>
        <li style="position: relative">
          <input @change="uploadEvidenceVideo" type="file" capture="camcorder" accept="video/*"
                 id="videoInput" name="videoInput" class="btn btn-primary btn-lg btn-block"
                 style="position: absolute; width: 100%; height: 100%; opacity: 0; z-index: 999; top:0; left: 0;">
          <i class="icon icon-addvideo"></i>
          添加视频
        </li>
        <li @click="uploadFinish" class="bg-danger"> 完成 </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import SignEvidence from '../../assets/js/http-serve/signEvidence';
  import {fileOperShow, ApiMethods} from '../../assets/js/http-serve/http-methods';
  import VideoSign from '../../assets/js/http-serve/video-sign'

  export default {
    name: "evidence",
    layout: 'empty',
    data () {
      return {
        signInfo:{signNo: '', sign: '', ts: ''},
        evidenceInfo: null,
        evidenceFront: null,  // 正面
        evidenceReverse: null, // 反面
        videoUrl: '',
        videoSignInfo: null,  // 视频签署
        loading: null
      }
    },
    mounted() {
      var query = this.$route.query;
      if (query) {
        this.signInfo = {signNo: query.signNo, sign: query.sign, ts: query.ts};
        this.getEvidenceInfo();
        this.queryVideoSignList(query.applyNo)
      }
    },
    methods: {
      // 签署视频列表
      queryVideoSignList(applyNo) {
        if (!applyNo) return false
        VideoSign.getVideoSignList(applyNo).then(({data}) => {
          this.videoSignInfo = data && data.length ? data : null
        }).catch(error => {})
      },
      // 播放视频
      playVideo (url) {
        if (url) {
          this.videoUrl = url;
        }
      },
      uploadFinish () {
        let param = {signNo: this.signInfo.signNo, sign: this.signInfo.sign, ts: this.signInfo.ts};

        SignEvidence.finish(param).then(() => {
          this.getEvidenceInfo();
          window.history.back();
        })
      },
      // 上传视频
      uploadEvidenceVideo(el) {
        var file = el.target.files[0];
        if (file.type.indexOf('video/') === -1) return this.$message.error('不是视频文件，请上传视频格式的文件');
        if (file.size > 300000 * 1024 * 1024) return this.$message.error('文件大小不能超过30M');
        var param = {signNo: this.signInfo.signNo, sign: this.signInfo.sign, ts: this.signInfo.ts, videoInput: file};
        this.loadingStart('正在上传视频信息');
        SignEvidence.uploadVideo(param).then((data) => {
          this.loadingClose();
          this.getEvidenceInfo();
        }).catch(err => {
          this.loadingClose();
          this.$message.error(err.description);
        });
      },
      // 图片删除点击触发按钮
      handleImgClick0 (upfile) { this.handleImgClick(upfile.raw, 0); },
      handleImgClick1 (upfile) { this.handleImgClick(upfile.raw, 1); },
      handleImgClick2 (el) { this.handleImgClick(el.target.files[0], 2);},
      handleImgClick (file, imgType) {
        var _this = this;
        if (file.type.indexOf('image/') === -1) return this.$message.error('不是图片文件，请上传图片文件');
        if (file.size > 30*1020*1024) return _this.$message.error('文件不能超过30M');
        _this.uploadEvidenceImg(file, imgType);
      },
      // 上传图片
      uploadEvidenceImg (file, imgtype) {
        var _this = this;
        var param = new FormData();
        param.append("imgdata", file);
        param.append("imgType", imgtype);
        param.append("signNo", _this.signInfo.signNo);
        param.append("sign", _this.signInfo.sign);
        param.append("ts", _this.signInfo.ts);
        _this.uploadPreImg(file);
        ApiMethods.SignEvidenceController.uploadImage(param).then(result => {
          if(result.success){
            _this.getEvidenceInfo();
          } else {
            _this.$message.error(result.description || this.$tip)
          }
        })
      },
      /**
       * 图片转二进制
       * @param file
       * @returns {Promise<any>}
       */
      uploadPreImg(file) {
        var _this = this;
        var fr = new FileReader();
        fr.onload = function () {
          var imgInfo = {url: this.result, isup: true};
          if (_this.evidenceInfo) {
            _this.evidenceInfo.push(imgInfo);
          } else {
            _this.evidenceInfo = [imgInfo];
          }
        };
        fr.onerror = function() {
          reject('文件读取失败');
        };
        fr.readAsDataURL(file);
      },
      // 删除
      delEvidence (evidenceId) {
        var param = {signNo: this.signInfo.signNo, sign: this.signInfo.sign, ts: this.signInfo.ts, evidenceId: evidenceId};

        this.$confirm('应用相关文件将被删除，您确认要删除这些应用么？', '系统提示', {showConfirmButton: true, showCancelButton: true, type: "info", width: '80%'}).then(() => {
          SignEvidence.del(param).then(() => {
            this.getEvidenceInfo();
          }).catch(err => {
            this.$message.error(err.description);
          })
        }).catch()
      },
      // 图片显示
      showImg (evidenceImg) {
        return fileOperShow(evidenceImg)
      },
      // 获取已经上传过的证据信息
      getEvidenceInfo () {
        SignEvidence.viewList(this.signInfo).then(({data}) => {
          if (data) {
            this.evidenceInfo = [];
            this.evidenceFront = null;
            this.evidenceReverse = null;
            data.forEach(t => {
              if (t.imgType == 0) {
                this.evidenceFront = t;
              } else if (t.imgType == 1) {
                this.evidenceReverse = t;
              } else {
                this.evidenceInfo.push(t)
              }
            })
          }
        }).catch(err => {
          this.$message.error(err.description);
        })
      },
      loadingStart (info) {
        this.loadingClose();

        this.loading = this.$loading({
          lock: true,
          text: info || '正在加载中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      },
      loadingClose () {
        if (this.loading) {
          this.loading.close();
          this.loading = null;
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  .evidence {
    width: 100%;
    overflow-x: hidden;
    overflow-y: auto;

    header {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 44px;
      line-height: 44px;
      background: #464c5c;

      p {
        color: #ffffff;
        text-align: center;
        font-size: 18px;
      }

      .icon {
        color: #fff;
        float: left;
        vertical-align: middle;
        margin-left: 7px;
        font-size: 24px;
        margin-top: 10px;
      }
    }

    .main {
      box-sizing: border-box;
      margin-top: 44px;
      padding: 10px;

      .remark {
        text-align: center;
        font-size: 12px;
        color: #969696;
        padding-top: 10px;
      }

      .list-sign {
        .sign-item {
          position: relative;
          margin-bottom: 10px;
          padding: 10px;
          background: #fff;
          color: #333333;
          -webkit-box-shadow: 0 0 6px rgba(0, 0, 0, .15);
          -moz-box-shadow: 0 0 6px rgba(0, 0, 0, .15);
          box-shadow: 0 0 6px rgba(0, 0, 0, .15);

          .video-sign {
            overflow: hidden;
            box-sizing: border-box;
            display: table;

            .logo {
              display: table-cell;
              width: 6em;
              height: 6em;
              background: url("/images/video-sign.png") no-repeat;
              background-size: contain;
            }
            .cont {
              display: table-cell;
              padding-left: 10px;
              vertical-align: middle;
              p {
                margin: 0;
                padding: 0;
              }
            }
          }

          .list-cel {
            display: table;
            width: 100%;
            padding-left: 0;
            margin: 0;
            margin-bottom: 10px;
            list-style: none;
            cursor: pointer;

            li {
              display: table-cell;
              padding: 4px;
              height: 80px;
              vertical-align: middle;
              position: relative;
              line-height: 24px;

              &:first-child {
                background: #f2f2f2;
                width: 6em;
                min-width: 60px;
                text-align: center;
                color: #969696;
              }

              img {
                max-height: 80px;
                max-width: 80px;
              }
              .play-video {
                vertical-align: middle;
                height: 24px;
                position: absolute;
                top: calc(50% - 12px);
                left: calc(50% - 12px);
                cursor: pointer;
              }
            }
          }

          p {
            padding-left: 10px;
            font-size: 14px;
            margin: 0 0 10px;
          }

          h3 {
            padding: 0 20px;
            margin: 0 0 10px 0;
            line-height: 50px;
            font-size: 18px;
            text-align: center;
            font-weight: 500;
          }
        }
      }
    }

    .footer {
      position: fixed;
      bottom: 0;
      left: 0;
      width: 100%;
      overflow: hidden;

      .navbar {
        box-sizing: border-box;
        margin-bottom: 0;
        table-layout: fixed;
        background: #464c5b;
        border-top: 1px solid #ebebeb;
        display: table;
        width: 100%;
        padding-left: 0;
        list-style: none;
        cursor: pointer;

        li {
          position: relative;
          text-align: center;
          vertical-align: middle !important;
          table-layout: fixed;
          display: table-cell;
          overflow: hidden;
          padding: 6px 0;
          font-size: 10px;
          color: #ffffff;
          cursor: pointer;

          input[type=file] {
            position: absolute;
            display: inline-block;
            width: 500%;
            height: 500%;
            top: -100%;
            left: -100%;
            opacity: 0;
            z-index: 10000;
            cursor: pointer;
          }

          .icon {
            display: block;
            width: 32px;
            height: 22px !important;
            margin: 0 auto 4px auto;
            background-size: contain;
            background-position: center;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// pages/m/evidence.vue